/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tabs[_ngcontent-c6][_ngcontent-%COMP%]{overflow:auto!important}"];
export { styles as styles };
